module.exports = __webpack_public_path__ + "static/img/brand_1.0a566bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_1.jpg
// module id = NKDY
// module chunks = 1